import { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useDispatch } from 'react-redux';

// import { processClaims } from 'utils/auth';
import { addRoles, checkManager } from 'store/modules/auth/auth.reducer';
import { ADMIN_ROLE, USER_ROLE } from 'utils/auth';

export const Auth = () => {
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();
  useEffect(() => {
    if (!keycloak.authenticated) return;
    const getClaims = async () => {
      try {
        // const roles = processClaims(keycloak?.realmAccess?.roles);
        const currentRoles = keycloak?.realmAccess?.roles || [];
        dispatch(addRoles(keycloak?.realmAccess?.roles || []));
        const isManager = !!(
          currentRoles?.length &&
          currentRoles.includes('read:manager') &&
          !currentRoles.includes(ADMIN_ROLE) &&
          !currentRoles.includes(USER_ROLE)
        );
        dispatch(checkManager(isManager));
      } catch (error) {
        console.log('get claims error', error);
      }
    };
    getClaims();
  }, [keycloak, dispatch]);

  return null;
};
